import React, { useState } from 'react';
import { 
  Container, 
  Typography, 
  Paper, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow,
  TablePagination,
  Link,
  Box,
  Button
} from '@mui/material';
import ArticleIcon from '@mui/icons-material/Article';

const ReleaseNotes = () => {
  // Sample release notes data
  const releaseNotesData = [
    { 
      version: "v1.2.3", 
      date: "2025-04-01", 
      docLink: "https://example.com/release-notes/v1.2.3"
    },
    { 
      version: "v1.2.2", 
      date: "2025-03-15", 
      docLink: "https://example.com/release-notes/v1.2.2" 
    },
    { 
      version: "v1.2.1", 
      date: "2025-02-28", 
      docLink: "https://example.com/release-notes/v1.2.1" 
    },
    { 
      version: "v1.2.0", 
      date: "2025-02-01", 
      docLink: "https://example.com/release-notes/v1.2.0" 
    },
    { 
      version: "v1.1.5", 
      date: "2025-01-15", 
      docLink: "https://example.com/release-notes/v1.1.5" 
    },
    { 
      version: "v1.1.4", 
      date: "2024-12-10", 
      docLink: "https://example.com/release-notes/v1.1.4" 
    },
    { 
      version: "v1.1.3", 
      date: "2024-11-20", 
      docLink: "https://example.com/release-notes/v1.1.3" 
    },
  ];

  // State for pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Format date to be more readable
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom align="center">
        Release Notes
      </Typography>
      
      <Paper elevation={3} sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                <TableCell><Typography variant="subtitle1" fontWeight="bold" textAlign="center">Version</Typography></TableCell>
                <TableCell><Typography variant="subtitle1" fontWeight="bold" textAlign="center">Release Date</Typography></TableCell>
                <TableCell><Typography variant="subtitle1" fontWeight="bold" textAlign="center">Documentation</Typography></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {releaseNotesData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((release) => (
                  <TableRow key={release.version} hover>
                    <TableCell  textAlign="center">
                      <Typography variant="body1" textAlign={"center"}>
                        {release.version}
                      </Typography>
                    </TableCell>
                    <TableCell  textAlign="center">
                      <Typography variant="body2" textAlign={"center"}>
                        {formatDate(release.date)}
                      </Typography>
                    </TableCell>
                    <TableCell 
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      {/* <Link 
                        href={release.docLink} 
                        target="_blank" 
                        rel="noopener"
                        sx={{ 
                          display: 'flex', 
                          alignItems: 'center',
                          textDecoration: 'none'
                        }}
                      >
                        <ArticleIcon sx={{ mr: 1 }} fontSize="small" />
                        View Release Notes
                      </Link> */}
                      <Button
                        variant="outlined"
                        color="primary"
                        // href={release.docLink}
                        target="_blank"
                        rel="noopener"
                        startIcon={<ArticleIcon />}
                        sx={{ 
                          textTransform: 'none',
                          fontSize: '0.875rem',
                        }}
                      >
                        View Release Notes
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={releaseNotesData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Container>
  );
};

export default ReleaseNotes;